import useTranslator from "../../hooks/useTranslator";
import { Button, Modal } from "../design";
import "./InsuranceSimulationErrorsModal.css";

const InsuranceSimulationErrorsModal = ({
  show,
  onHide,
  errors,
  type,
  onAction,
}) => {
  const { _t } = useTranslator();
  const isPropertyError = type === "property";
  const title = isPropertyError
    ? _t("missingPropertyDetails")
    : _t("pleaseAddMissingDetailsForInsurance");
  const description = isPropertyError
    ? _t("fillFollowingFieldsInPropertySettingsToContinue")
    : "";
  const actionLabel = _t("goToPropertySettings");

  return (
    <Modal
      open={show}
      onClose={onHide}
      id="insurance-simulation-errors-modal"
      align="start"
      icon={
        <div className="d-flex align-items-center justify-content-center rounded-circle error-icon-bg">
          <img src="/images/red-error.svg" alt="Error" />
        </div>
      }
      title={title}
      description={_t("requiredBeforeAwardingInsurance")}
      actions={
        isPropertyError && (
          <>
            <Button variant="secondary" size="lg" onClick={onHide}>
              {_t("cancel")}
            </Button>
            <Button size="lg" onClick={onAction}>
              {actionLabel}
            </Button>
          </>
        )
      }
    >
      <div className="insurance-simulation-errors-modal">
        <div className="property-errors-main-container mb-2">
          {description && (
            <p className="property-errors-description">{description}</p>
          )}
          <ul className={isPropertyError ? "property-errors-list-plain" : ""}>
            {errors.map((error, index) => (
              <li
                className={
                  isPropertyError
                    ? ""
                    : "d-flex align-items-start gap-6px insurance-error-row"
                }
                key={index}
              >
                {!isPropertyError && (
                  <img src="/images/red-error.svg" alt="Error" />
                )}
                <span
                  className={!isPropertyError ? "insurance-error-text" : ""}
                >
                  {error}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
};

export default InsuranceSimulationErrorsModal;
